import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/apple_store.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/award1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/award2.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/award3.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/award4.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/ddrc-app-download-qr.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/downloadAppImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/ecg.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/electrocardiogram.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/google_play.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/mammography.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/PFT.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/TMT.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/ultrasound.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/xray.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/ContactOnCall.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/ContactOnWhatsApp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/AwardsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/CompleteCarePackageSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/ExploreByHealthNeed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/FAQExpandToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/FeatureSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/LandingPage/HealthScansAndImagingTest.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/MostPopularHealthCheckups.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/QualityExpertiseSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LandingPage/TestimonialSlider.tsx");
